import { useState, useEffect } from "react";
import { useRouterContext } from "@refinedev/core";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

import { DocumentDisplay } from "components/Panel/Admin/Documents/DocumentDisplay";
import { getDocument } from "api/admin";

export const DocumentationPage: React.FC = () => {
    const { useParams } = useRouterContext();
    const { id } = useParams<{ id: string }>();

    const [doc, setDoc] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            setLoading(true);
            const doc = await getDocument(id);
            setLoading(false);
            setDoc(doc.data);
        })();
    }, [id]);

    return loading ? (
        <Spin
        spinning
        size="large"
        indicator={
            <LoadingOutlined
                style={{ fontSize: 48, color: "white" }}
                spin
            />
        }
    />
    ) : <DocumentDisplay title={doc?.title} content={doc?.content} />;
};
